const semiUi: Record<string, string> = {
  '文件大小超出限制，请重新上传': 'The file size exceeds the limit. Please upload again.',
  请选择表格中展示的信息: 'Select columns to display',
  重新获取: 'Resend',
  请输入: 'Please enter ',
  头像文件过大: 'Avatar file is too large.',
  图片剪裁: 'Crop Image',
  上传头像: 'Upload',
  重试: 'Retry',
  离开后变更不会被保存且无法恢复:
    'The changes will not be saved and cannot be restored after you leave this page.',
  已选上级不可取消: 'The selected parent cannot be deselected.',
  开发者信息: 'Developer Info',
  已被添加: 'Already added',
  '{label}超出 {limit} 的上限，请删减': '{label} exceeds the limit of {limit}. Please reduce it.',
  复制成功: 'Copied successfully',
  '文件错误，请重新上传': 'Incorrect file. Please upload again.',
  暂无数据: 'No data',
  '仅支持{sizeMB}M以内的 {accept} 文件': 'Only {accept} files within {sizeMB} MB are supported.',
  '加载中...': 'Loading...',
  清空: 'Clear',
  当前页面出现异常: 'An error occurred on the current page.',
  上传国徽面: 'Upload Back Side',
  操作: 'Operation',
  暂不支持HEIC格式图片上传: 'HEIC images are currently not supported.',
  '文件存在风险，请重新上传': 'The file poses a risk. Please upload again.',
  下一步: 'Next',
  文件上传失败: 'File upload failed',
  '暂无符合条件的内容，请尝试修改查找条件': 'No results found. Please modify the search criteria.',
  取消上传: 'Cancel Upload',
  扫码成功: 'Scanned successfully',
  文件上传中: 'Uploading',
  头像存在风险: 'Avatar involves risks.',
  重新选择: 'Reselect',
  返回: 'Back',
  取消: 'Cancel',
  头像不支持HEIC: 'HEIC format is not supported for avatar.',
  刷新: 'Refresh',
  请输入手机号: 'Enter mobile number',
  请选择: 'Please Select ',
  全部部门和成员: 'All Departments & Members',
  头像文件错误: 'Avatar file error.',
  恢复默认: 'Reset',
  旋转: 'Rotate',
  复制: 'Copy',
  已选: 'Selected',
  批量操作: 'Batch Operation',
  加载失败: 'Loading failed',
  '已选 {count} {suffix}': '{count} {suffix} selected',
  '正在选中...': 'Selecting...',
  '文件格式不正确，请重新上传': 'Incorrect file format. Please upload again.',
  查看更多: 'View More',
  请在微信中完成录入: 'Please complete the process in WeChat.',
  '上传中...': 'Uploading...',
  提交: 'Submit',
  未知错误: 'Unknown error',
  上传人像面: 'Upload Front Side',
  搜索中: 'Searching',
  '共 {total} 条': '{total} in total',
  文件过大: 'The file is too large.',
  '文件过大，请重新上传': 'The file is too large. Please upload again.',
  '重新获取({time})': 'Resend ({time})',
  上传文件: 'Upload File',
  '加载失败，请重新上传': 'Loading failed. Please upload again.',
  '已被添加，无需重复勾选': 'Already added. You do not need to select it again.',
  '您有未保存的变更，确定要离开吗？': 'You have unsaved changes. Are you sure you want to leave?',
  暂无数据提示: 'No data',
  重新上传: 'Re-upload',
  确认离开: 'Confirm Leave',
  '正在加载...': 'Loading...',
  保存: 'Save',
  头像加载失败: 'Avatar load failed.',
  刷新二维码: 'Refresh QR Code',
  请输入验证码: 'Enter verification code',
  请输入关键字搜索: 'Enter keywords to search',
  获取验证码: 'Send',
  名称: ' name',
  '当前批量操作最多支持{limit}条数据': 'The batch operation supports a maximum of {limit} entries.',
  头像格式不正确: 'Invalid avatar format.',
  图片无法显示: 'The image cannot be displayed.',
  确认: 'Confirm',
  '文件格式错误，请重新上传': 'Incorrect file format. Please upload again.',
  上一步: 'Previous',
  扫码失败: 'Scanning failed',
  加载中: 'Loading',
  不支持上传的文件类型: 'Unsupported file type',
  '加载中…': 'Loading…',
};
export default semiUi;
